module.exports = __webpack_public_path__ + "media/theme/about-us-wall-78dd3b96.png";